// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2jQJH","assignButton":"CreateEditEquipmentSchedule_assignButton__-_Rak"};